import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text20 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {rightsPermitRami} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(rightsPermitRami) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <div className={styles.bold}>אישור זכויות רמ"י: </div>
          <span>{getBreakLinesTextShumaType3(rightsPermitRami)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text20;
